const isDev = process.env.NODE_ENV !== 'production';

export const logger = {
    warn: (...args) => {
        if (isDev) console.warn('[WARN]', ...args);
    },
    error: (...args) => {
        console.error('[ERROR]', ...args);
    },
};
